<template>
	<div class="featured_people_listing">
		<div class='container'>
			<div class='upper'>
				<h2 v-html="title"></h2>
				<div class='right'>
					<div
						class='description'
						v-html='description'
					></div>
					<a
						:href='parsedCta.url'
						:target='parsedCta.target'
						v-html='parsedCta.title'
					></a>
				</div>
			</div>
			<div class='inner'>

			</div>
		</div>
		<div class="container">
			<person-tile
				v-for="(person, index) in parsedPeople"
				:image="person.image.url"
				:full_name="person.full_name"
				:position="person.position"
				:bio="person.bio"
				:excerpt="person.excerpt"
				:linkedin="person.linkedin"
				:key="index"
				:class="{'full-width': Object.keys(parsedPeople).length <= 1}"
				data-aos="fade-up"
				data-aos-duration="300"
				:data-aos-offset="50"
				:data-aos-delay="index * 50"
			></person-tile>
		</div>
	</div>
</template>

<script>
import PersonTile from './PersonTile.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			swiper: null,
		};
	},

	props: {
		title: {},
		description: {},
		cta: {},
		people: {},
		type: {},
		section_id: {},
		no_slider: {
			default: 'false',
		},
	},

	computed: {
		parsedPeople() {
			if (this.people) {
				return JSON.parse(this.people);
			} else {
				return null;
			}
		},

		parsedCta() {
			if (this.cta) {
				return JSON.parse(this.cta);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {
		PersonTile,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.featured_people_listing {
	border-top: 1px solid var(--light-grey);
	background: var(--very-light-grey);
	padding-bottom: 50px;

	.template-team & {
		background: transparent;
		margin-top: 50px;
	}

	.container {
		gap: 0;
	}

	.upper {
		grid-column: span 12;
		display: grid;
		grid-template-columns: 1fr 1fr;
		padding: 50px 0 30px;

		@media (max-width: $mobile) {
			grid-template-columns: unset;
			grid-template-rows: 1fr 1fr;
		}

		h2 {
			font-weight: 300;
			max-width: 50%;
			color: var(--grey);

			@media (max-width: $mobile-xl) {
				max-width: 100%;
			}
		}

		.right {
			display: flex;
			flex-direction: column;

			.description {
				max-width: 50%;
				color: var(--grey);
				margin-bottom: 24px;

				@media (max-width: $mobile-xl) {
					max-width: 100%;
				}

				@media (max-width: $mobile) {
					margin-bottom: 0;
				}

				&::v-deep {
					p {
						&:first-of-type {
							margin-top: 0;
						}

						&:last-of-type {
							margin-bottom: 0;
						}
					}
				}
			}

			a {
				color: var(--duco-blue);
				text-decoration: none;

				&::after {
					content: '\2192';
					margin-left: 5px;
				}
			}
		}
	}

	.inner {
	}
}
</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/FeaturedPeopleListing.vue